import script from "./TermsOfUse.vue?vue&type=script&setup=true&lang=ts"
export * from "./TermsOfUse.vue?vue&type=script&setup=true&lang=ts"

import "./TermsOfUse.vue?vue&type=style&index=0&id=461cc678&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-461cc678"]])

export default __exports__